const invalidSchedule = () => new Error('Horaire de précommande invalide : récupérez la commande avant impression. Aucune impression lancée.');

// A reprint uses the original pickup instant and establishment timezone, even
// after pickup. Never infer a preorder from notes, local time or current settings.
export function normalizePrintSchedule(options = {}) {
  const source = options.schedule;
  const mode = source?.mode ?? options.pickupMode;
  if (mode === undefined || mode === null || mode === 'immediate') {
    if (options.pickupMode === 'scheduled') throw invalidSchedule();
    return null;
  }
  if (mode !== 'scheduled') throw invalidSchedule();
  const savedPickupAt = source?.pickupAt ?? options.pickupAt;
  const pickupAt = savedPickupAt instanceof Date && Number.isFinite(savedPickupAt.getTime())
    ? savedPickupAt.toISOString() : savedPickupAt;
  const timezone = source?.timezone ?? options.pickupTimezone;
  if (typeof pickupAt !== 'string' || !/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d{3})?Z$/.test(pickupAt)
    || typeof timezone !== 'string' || !timezone || timezone.length > 100) throw invalidSchedule();
  const instant = new Date(pickupAt);
  if (!Number.isFinite(instant.getTime()) || instant.toISOString().slice(0, 19) !== pickupAt.slice(0, 19)) throw invalidSchedule();
  try {
    new Intl.DateTimeFormat('fr-FR', { timeZone: timezone }).format(instant);
  } catch (_) {
    throw invalidSchedule();
  }
  return { mode: 'scheduled', pickupAt: instant.toISOString(), timezone };
}

export function formatPreorderTicket(options = {}) {
  const schedule = normalizePrintSchedule(options);
  if (!schedule) return null;
  const parts = new Intl.DateTimeFormat('fr-FR', {
    timeZone: schedule.timezone, year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit', hourCycle: 'h23',
  }).formatToParts(new Date(schedule.pickupAt));
  const part = type => parts.find(value => value.type === type)?.value;
  const date = `${part('day')}/${part('month')}/${part('year')}`;
  const time = `${part('hour')}:${part('minute')}`;
  return { schedule, date, time, lines: ['PRÉCOMMANDE', 'RETRAIT', date, time] };
}
